import wx from 'jweixin-module';
import ap from 'Ap';
import { getWeChatConfig } from '@/api/api-ticket.js';
import Store from '@/store';

// 微信 获取权限验证配置，然后通过config接口注入
export const handelWeChatConfig = async (data = {}) => {
  try {
    const path = window.location.href || Store.getters.wechatUrl;
    const { url, beta, ...config } = await getWeChatConfig({ path });
    await wx.config(config);

    const { title = '票务系统', desc = '', link = '', imgUrl = '' } = data;
    const spotId = window.sessionStorage.getItem('spotId');
    let links = link;
    if (path.indexOf('?') < 0) {
      links = `${path}?spot_id=${spotId}`;
    } else if (path.indexOf('spot_id' < 0)) {
      links = `${path}&spot_id=${spotId}`;
    }
    wx.ready(() => {
      wx.updateAppMessageShareData({
        title, // 分享标题
        desc: desc || links, // 分享描述
        link: links, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl, // 分享图标
      });
      wx.updateTimelineShareData({
        title, // 分享标题
        link: links, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl, // 分享图标
      });
    });
  } catch (error) {}
};

// 微信打开扫一扫
export const handelWeChatScanQRCode = () => {
  return new Promise((resolve, reject) => {
    wx.scanQRCode({
      needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
      success: res => {
        resolve(res);
      },
      fail: err => {
        reject(err);
      },
    });
  });
};

// 使用微信分享给朋友及分享到QQ
export const handelWechatAppShare = () => {
  wx.updateAppMessageShareData({
    title: '分享朋友标题', // 分享标题
    desc: '分享朋友描述', // 分享描述
    link: '分享朋友链接', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: '', // 分享图标
  });
};
// 使用微信分享到朋友圈及分享到QQ空间
export const handelWechatTimeShare = () => {
  wx.updateTimelineShareData({
    title: '分享朋友圈标题', // 分享标题
    link: '分享朋友圈链接', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: '', // 分享图标
  });
};
// 微信上传图片
export const chooseImageWeChat = () => {
  return new Promise((resolve, reject) => {
    wx.chooseImage({
      count: 1, // 默认9
      sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      success: res => {
        const { localIds } = res; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
        const [url] = localIds;
        wx.getLocalImgData({
          localId: url, // 图片的localID
          success: result => {
            const { localData } = result; // localData是图片的base64数据，可以用img标签显示
            let localUrl = '';
            // ios wkwebwiew 内核
            if (window.__wxjs_is_wkwebview) {
              localUrl = localData.replace('jgp', 'jpeg');
            } else {
              // ios  android
              localUrl = `data:image/jpeg;base64,${localData}`;
              localUrl = localUrl.replace(/\r|\n|\\s/g, '');
            }
            resolve(localUrl);
            reject();
          },
          fail: () => {},
        });
      },
      fail: () => {},
    });
  });
};

// 支付宝上传图片
export const chooseImageAli = () => {
  return new Promise((resolve, reject) => {
    ap.chooseImage(1, ({ apFilePaths, apFilePathsV2 }) => {
      let apFilePath = apFilePathsV2 || apFilePaths || [];
      if (typeof apFilePath === 'string') {
        try {
          apFilePath = JSON.parse(apFilePath);
        } catch (e) {}
      }
      if (!apFilePath.length || !/^https?:/.test(apFilePath[0])) {
        return;
      }
      // 获取图片文件路径
      const [imgUrl] = apFilePath;
      // 获取base64数据
      const image = new Image();
      image.src = imgUrl;
      image.crossOrigin = 'anonymous';
      image.onload = () => {
        let canvas = document.createElement('CANVAS');
        const context = canvas.getContext('2d');
        canvas.height = image.height;
        canvas.width = image.width;
        context.drawImage(image, 0, 0);
        try {
          const dataURL = canvas.toDataURL('image/jpeg');
          resolve(dataURL);
          reject();
        } catch (e) {
          this.$toast.fail('错误：请重新选取');
        }
        canvas = null;
      };
    });
  });
};

// 微信支付
export const payoffByWechat = data => {
  return new Promise((resolve, reject) => {
    window.WeixinJSBridge.invoke('getBrandWCPayRequest', data, res => {
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        resolve();
      } else {
        reject(res.errMsg);
      }
    });
  });
};
// const payoffByWechat = data => {
//   return new Promise(resolve => {
//     const { timeStamp, nonceStr, signType, paySign, package: packAge } = data;
//     wx.chooseWXPay({
//       timestamp: timeStamp,
//       nonceStr,
//       package: packAge,
//       signType,
//       paySign,
//       success: () => {
//         resolve();
//       },
//     });
//   });
// };
// 支付宝支付
const payoffByAlipay = data => {
  return new Promise((resolve, reject) => {
    window.AlipayJSBridge.call('tradePay', { tradeNO: data.trade_no }, res => {
      if (res.resultCode === '9000') {
        resolve();
      } else {
        reject(res.resultCode);
      }
    });
  });
};
// const payoffByAlipay = data => {
//   return new Promise(resolve => {
//     ap.tradePay({ tradeNO: data.trade_no }, res => {
//       if (res.resultCode === '9000') {
//         resolve();
//       }
//     });
//   });
// };
// 选择支付方式
export const choosePayment = data => {
  if (window.WeixinJSBridge) {
    window.location.href = `https://zgy.djlnet.com.cn/yjt_mobile_ticket/unify_pay?token=${data.token}`;
  }
  if (window.AlipayJSBridge) {
    return payoffByAlipay(data);
  }
  return undefined;
};
